module.exports = __webpack_public_path__ + "static/media/logo_fundo_transparente.6d6ad2a6.png";